import { Component } from '@angular/core';
import { UploadAbstractComponent } from '../upload/upload.abstract';

@Component({
    standalone: false,
    selector: 'mibi-upload-action-item',
    templateUrl: './upload-action-item.component.html'
})
export class UploadActionItemComponent extends UploadAbstractComponent {

}
